import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5340efc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "branch" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topTitle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "topTitleText" }, " 研究表明莫匹罗星不良反应率低,联合激素治疗儿童AD疗效 优于单用激素 ")
], -1))
const _hoisted_4 = { class: "showBox" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"boxWrap\" data-v-5340efc9><div class=\"smallbox\" data-v-5340efc9><div class=\"smallTitle\" data-v-5340efc9>有效率高</div></div><div class=\"bottomWarp\" data-v-5340efc9><div class=\"inBox\" data-v-5340efc9> 一项纳入116例AD患儿随机对照研究显示，百多邦®莫匹罗星软膏联合激素治疗AD患儿，临床治愈率及总有效率分别<span class=\"red\" data-v-5340efc9>58.49%</span>和<span class=\"red\" data-v-5340efc9>92.45%</span>，均优于单用激素治疗（P＜0.05） <div class=\"pd\" data-v-5340efc9></div> 并且联合组缩短皮损消退（8.94天→6.15天）及止痒时间（4.8天→<span class=\"red\" data-v-5340efc9>2.48天</span>） </div></div></div><div class=\"boxWrap\" style=\"margin-top:-0.4667rem;\" data-v-5340efc9><div class=\"smallbox2\" data-v-5340efc9><div class=\"smallTitle\" data-v-5340efc9>不良反应率低</div></div><div class=\"bottomWarp\" data-v-5340efc9><div class=\"inBox\" data-v-5340efc9> 百多邦®莫匹罗星软膏治疗小儿皮肤感染用药期间60例患儿<span class=\"red\" data-v-5340efc9>仅2例</span>出现局部<span class=\"red\" data-v-5340efc9>轻微痒感</span>，不良反应率较低，而对照组给予鱼石脂软膏与红霉素软膏治疗患儿不良反应率为65% </div></div></div>", 2)
const _hoisted_7 = {
  class: "boxWrap",
  style: {"margin-top":"-0.8667rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallbox3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "smallTitle" }, "用法用量")
], -1))
const _hoisted_9 = { class: "bottomWarp" }
const _hoisted_10 = { class: "inBoxTwo" }
const _hoisted_11 = { class: "icoOne" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconText" }, "局部涂于患处，必要时患处可用敷料包扎或覆盖", -1))
const _hoisted_13 = { class: "inBoxTwo" }
const _hoisted_14 = { class: "icoOneTwo" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconText" }, [
  /*#__PURE__*/_createTextVNode(" 每日3次，5天一疗程，"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "必要时重复一疗程*")
], -1))
const _hoisted_16 = { class: "yellow" }
const _hoisted_17 = { class: "gantan" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yellowText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, [
    /*#__PURE__*/_createElementVNode("i", null, "应足疗程使用")
  ]),
  /*#__PURE__*/_createTextVNode("，"),
  /*#__PURE__*/_createElementVNode("i", null, "症状未消失、未痊愈，不宜过早停止用药！")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footText" }, " *由于不同皮肤及软组织感染疾病的指南/共识建议疗程不同， 医生可根据患者感染征象的情况，确定延长疗程时间 ", -1))
const _hoisted_20 = { class: "bangbox" }
const _hoisted_21 = { class: "yaohe" }
const _hoisted_22 = { class: "bxs" }
const _hoisted_23 = { class: "home" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1. Sun D, et al. Immunol Allergy Clin North Am. 2017,37(1):75-93."),
  /*#__PURE__*/_createElementVNode("span", null, " 2. Wang V, et al . Ann Allergy Asthma Immunol. 2021 Jan;126(1):3-12."),
  /*#__PURE__*/_createElementVNode("span", null, " 3. 郝飞. 临床皮肤科杂志,2002,31(6):402-404.")
], -1))
const _hoisted_25 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.1333rem",
        height: ".6667rem",
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_image, {
                width: "1rem",
                height: "1rem",
                src: require('../assets/xian.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_image, {
                width: "1rem",
                height: "1rem",
                src: require('../assets/yuan.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_van_image, {
                  width: "1.2rem",
                  height: "1.2rem",
                  src: require('../assets/san.png')
                }, null, 8, ["src"])
              ]),
              _hoisted_18
            ]),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_van_image, {
                  width: "4.8rem",
                  height: "2rem",
                  src: require('../assets/yaohe.png')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_van_image, {
                  width: "2.6rem",
                  height: "4rem",
                  src: require('../assets/bxs.png')
                }, null, 8, ["src"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_van_image, {
                  onClick: $options.showPopup,
                  width: "2.5733rem",
                  height: "2.5733rem",
                  src: require('../assets/jixu.png')
                }, null, 8, ["onClick", "src"]),
                _createVNode(_component_van_image, {
                  class: "finger",
                  width: "1.28rem",
                  height: "1.28rem",
                  src: require('../assets/dong.gif')
                }, null, 8, ["src"])
              ]),
              _createVNode(_component_van_popup, {
                show: $data.show,
                "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
              }, {
                default: _withCtx(() => [
                  ($data.flag)
                    ? (_openBlock(), _createBlock(_component_medical, {
                        key: 0,
                        onOnChanged: $options.updateChanged,
                        postaimqus: $data.postaimqus
                      }, null, 8, ["onOnChanged", "postaimqus"]))
                    : _createCommentVNode("", true),
                  (!$data.flag)
                    ? (_openBlock(), _createBlock(_component_medical, {
                        key: 1,
                        onOnChanged: $options.updateChanged,
                        postaimqus: $data.postaimqus
                      }, null, 8, ["onOnChanged", "postaimqus"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["show"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}